const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/reducers/labReports/loadCumulConfigHandlers.ts';
import Imm from 'immutable';
import { incCounter, decCounter } from '../../utils/reducerUtils';
import { IKisApiHandlersMap } from '../../defs/actionTypes';
import { LoadCumulConfigAction } from '../../actions/labReportsActions';

import { Logger } from '../../services/KisLoggerService';

const Log = Logger('labReports/loadCumulConfig');

export const loadCumulConfigHandlers: IKisApiHandlersMap<LoadCumulConfigAction> = {
    pending: state => {
        return incCounter(state, ['loading', 'config']);
    },
    success: (state, action) => {
        // The _empty field makes sure we have something inside the config even if the CONTENT was empty.
        // loadCumulDefsSaga relies on it.
        const cfg = Imm.fromJS((action.payload && action.payload.CONTENT) || { _empty: true });
        state = state.set('config', cfg);
        return decCounter(state, ['loading', 'config']);
    },
    failure: (state, action) => {
        Log.warn('Failed to load the cumul config!', action);
        return decCounter(state, ['loading', 'config']);
    },
};
